import { render, staticRenderFns } from "./TotalSales.vue?vue&type=template&id=2798fd3c&"
import script from "./TotalSales.vue?vue&type=script&lang=js&"
export * from "./TotalSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports